import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button, Stack, TextField } from '@mui/material';
import AuthShell from '../components/AuthShell';
import { api, apiErrorMessage } from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
    } catch (err) {
      setError(apiErrorMessage(err, 'Could not send reset email.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Forgot password"
      subtitle="We'll email you a reset link if your account exists."
      footer={<RouterLink to="/login" aria-label="Back to sign in">Back to sign in</RouterLink>}
    >
      {done ? (
        <Alert severity="success">If an account exists for {email}, a reset email is on its way.</Alert>
      ) : (
        <form onSubmit={onSubmit} aria-label="Forgot password form">
          <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            <TextField
              label="Email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              inputProps={{ 'aria-label': 'Email address' }}
            />
            <Button type="submit" variant="contained" size="large" disabled={busy} aria-label="Send reset link">
              {busy ? 'Sending…' : 'Send reset link'}
            </Button>
          </Stack>
        </form>
      )}
    </AuthShell>
  );
}
